import { Button, ButtonProps, HStack, Icon, Text } from '@chakra-ui/react';
import React from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

interface NavButtonProps extends ButtonProps {
  icon: any;
  label: string;
  to: string;
}

export const NavButton = (props: NavButtonProps) => {
  const { icon, label, to, ...buttonProps } = props;
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: true });

  const variant = match ? 'outline' : 'ghost-on-accent';

  return (
    <Link to={to}>
      <Button
        variant={variant}
        justifyContent="start"
        {...buttonProps}
        minW="100%"
      >
        <HStack spacing="3">
          <Icon as={icon} boxSize="6" color="on-accent-subtle" />
          <Text>{label}</Text>
        </HStack>
      </Button>
    </Link>
  );
};
